import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export default function OfflineIndicator() {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      className="fixed top-2 inset-x-0 z-[70] flex justify-center pointer-events-none animate-fade-up"
      data-testid="offline-indicator"
    >
      <div className="pointer-events-auto inline-flex items-center gap-2 bg-slate-900 text-white text-xs font-semibold px-3 py-1.5 rounded-full shadow-lg">
        <WifiOff className="w-3.5 h-3.5" />
        Mode hors-ligne — catalogue disponible
      </div>
    </div>
  );
}
